// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { TimeBaseEntity } from '../time-base-entity';

/// <code-import> Place custom imports between <code-import> tags
export enum RecoveryStatus  {
  high = 'High',
  low = 'Low',
  percentage = 'Percentage',
  amount = 'Amount',
}

export type SetRecoveryFlags = 'Locked';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class SetRecoveryStatus extends TimeBaseEntity  {

  /// <code> Place custom code between <code> tags
  hasFlag(flag: SetRecoveryFlags): boolean {
    const flags = this.parseFlags();
    return flags.some((f) => f === flag);
  }

  setFlag(flag: SetRecoveryFlags): void {
    if (this.hasFlag(flag)) {
      return;
    }

    const flags = this.parseFlags();
    flags.push(flag);
    this.flags = flags.join(', ') || '0';
  }

  clearFlag(flag: SetRecoveryFlags): void {
    if (!this.hasFlag(flag)) {
      return;
    }

    const flags = this.parseFlags();
    flags.splice(flags.indexOf(flag), 1);
    this.flags = flags.join(', ') || '0';
  }

  private parseFlags(): string[] {
    const flags = this.flags || '0'; // Could be numeric zero
    if (flags === '0') {
      return [];
    }
    return flags.split(',').map((flag) => flag.trim());
  }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  adminId!: number;
  adminTypeId?: number;
  amount?: number;
  comment?: string;
  createdAt!: Date;
  createdBy?: string;
  endDate?: Date;
  flags!: string;
  percentage?: number;
  status?: string;
  statusDate?: Date;
  ts?: any;
  updatedAt!: Date;
  updatedBy?: string;
}

